import React, {useContext} from 'react';
import { useNavigate } from 'react-router';
import { Context } from '../../../context/ContextData';
import { FaSearch } from "react-icons/fa";
import {Link} from "react-router-dom";

const SearchResult = () => {


  const {setTopSearch,topSearch} = useContext(Context);
  const navigate = useNavigate();

  const searchInside = () => {
    // e.preventDefault()
    if(topSearch){
      navigate(`/response/${topSearch}`)
      setTopSearch("")
    }
  }
    return (
        <div className="d-flex justify-content-center align-items-center mt-5 ">
        <nav className="d-flex flex-column gap-3 search-bar top-form col-10 col-lg-7">
          <div className="d-flex align-items-center justify-content-center gap-2">
            <Link to="/" className="navbar-brand" ><img className="logo-nav" src='/images/logo.png' /></Link>
            <h5 className="guid-text text-white text-center">به مرکز پاسخگوی هوشمند سازمان امور مالیاتی کشور خوش آمدید</h5>
          </div>
          <div className="w-100 ">
            <form onSubmit={searchInside} className="d-flex  justify-content-center w-100 position-relative">
              <input onChange={e => setTopSearch(e.target.value)} className="form-control input-form"  type="text"
                placeholder={"چطور میتوانیم به شما کمک کنیم؟"} aria-label="چطور میتوانیم به شما کمک کنیم؟" /> 
                <button type="submit" onSubmit={searchInside} className="search-btn" >
                <FaSearch style={{position:"absolute" , top:"12px", left:"5px", fontSize:"25px", cursor:"pointer"}}/>
                </button>
            </form>
          </div>
        </nav>
      </div>
    );
};

export default SearchResult;